<template>
  <div class="St-home center-block">
    <div class="St-login">
      <div class="Vlt-card Vlt-card--image Vlt-bg-white">
        <div class="Vlt-card__image2">
          <img src="../assets/logos/vonage-logo.svg" alt="logo">
        </div>
        <div class="Vlt-card__content">
          <div class="Vlt-grid">
            <div class="Vlt-col Vlt-col--center">
              <h3 >{{ $t('message.login.loginTo2') }}</h3>
              <vlt-callout v-if="apiError && apiError.code" type="critical">
                <h4>{{$t(`message.errors.${apiError.code}.title`)}}</h4>
                <p>{{$t(`message.errors.${apiError.code}.text`)}}</p>
              </vlt-callout>
              <!-- LOGIN STEP 1 -->
              <div v-if="authStep==1">
                <vlt-field big :error="errorNumberFormat">
                  <VltInputCustom
                    v-model="number"
                    type="tel"
                    required
                    id="number"
                    :label="$t('message.login.inputLabel')"
                    :placeholder="$t('message.login.inputLabel')"
                    :val="number"
                    :refC="inputStepRef"
                    :focus="true"
                    :onEnter="submitLoginStep1"
                  ></VltInputCustom>
                </vlt-field>
                <vlt-button
                  large
                  app
                  :label="$t('message.login.submit')"
                  @click="submitLoginStep1" primary
                  :spinner="loading"
                  :disabled="loading===true || number==='' || errorNumberFormat !== '' || number.length < 10 "
                >
                </vlt-button>
              </div>
              <!-- LOGIN STEP 2 -->
              <div v-if="authStep==2">
                <div v-if="number">Your number: {{number}}</div>
                <vlt-field big :error="errorInvalidCode">
                  <VltInputCustom
                    v-model="code"
                    type="text"
                    id="code"
                    :label="$t('message.login.inputLabel2')"
                    :placeholder="$t('message.login.inputLabel')"
                    :val="code"
                    :refC="inputStepRef"
                    :focus="true"
                    :onEnter="submitLoginStep2"
                   />
                </vlt-field>
                <vlt-button
                  large
                  app
                  :label="$t('message.login.verify_code')"
                  @click="submitLoginStep2" primary
                  :spinner="loading"
                  :disabled="loading===true || code==='' || errorInvalidCode !== '' "
                >
                </vlt-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  VltSpinner,
  VltButton,
  VltCallout,
  VltField, VltInput,
} from '@vonagevolta/vue';
import VltInputCustom from 'Components/common/VltInputCustom';
import {
    ERROR_CODES,
} from "Constants/nciConstants";

import { mapGetters, mapActions } from 'vuex';
import {
  LOGIN_STEP1_SUBMIT_NUMBER,
  LOGIN_STEP2_SUBMIT_VERIFICATION_CODE,
  SET_API_ERROR_ACTION,
} from 'Store/action-types';

export default {
  name: 'login',
  components: {
    VltSpinner,
    VltButton,
    VltCallout,
    VltField,
    VltInput,
      VltInputCustom,
  },
  data() {
    return {
      errorMessage: undefined,
      isLoggingIn: false,
      // errorApiKey: '',
      errorNumberFormat: '',
      errorInvalidCode: '',
      authStep: 1,
      number: '',
      validatedNumber: '',
      code: '',
      inputStepRef: 'inputStep1',
    };
  },
  // directives: {
  //     focus: {
  //         inserted: function (el) {
  //             el.focus()
  //         }
  //     }
  // },
  computed: {
    isAuthenticated() {
      return this.$auth.isAuthenticated;
    },
    ...mapGetters({
      isAdmin: 'isAdmin',
      verifyNumberId: 'getVerifyNumberId',
      verifyNumberErr: 'getVerifyNumberErr',
      loading: 'getLoading',
      loggedIn: 'isLoggedIn',
      apiError: 'getApiError',
      userLoginNumber: 'getUserLoginNumber',
    }),
  },
  methods: {
      // focusInput( inputRef ) {
      //   console.log('inputRef: ', inputRef)
      //   console.log('this.$refs: ', this.$refs);
      //   if ( this.$refs[inputRef] && this.$refs[inputRef].focus) {
      //       this.$refs[inputRef].focus();
      //   }
      // },
    ...mapActions({
        submitPhoneNumber: `${LOGIN_STEP1_SUBMIT_NUMBER}`,
        submitVerificationCode: `${LOGIN_STEP2_SUBMIT_VERIFICATION_CODE}`,
        setApiError: `${SET_API_ERROR_ACTION}`,
    }),
      /**
       *@description - Submit phone number
       * @returns {Promise<void>}
       */
    async submitLoginStep1() {
      const isValidNumber = this.isValidNumber(this.number);
      if (this.validatedNumber && isValidNumber && this.authStep === 1) {
        this.errorMessage = undefined;
        this.errorNumberFormat = '';
        this.submitPhoneNumber(this.validatedNumber);
      } else {
          this.errorNumberFormat = this.$i18n.t('message.login.error3');
      }
    },
    async submitLoginStep2() {
        const isValidCode = this.isValidCode(this.code.trim());
        if (this.validatedNumber && isValidCode && this.authStep === 2) {
          this.errorMessage = undefined;
          this.errorInvalidCode = '';
          try {
            // Call API
            this.submitVerificationCode(this.code);
          } catch (error) {
              this.errorMessage = this.$i18n.t('message.login.error', { error });
          }
        } else {
            this.errorInvalidCode = this.$i18n.t('message.login.error4');
        }
    },
    validateNumber(number) {
      if (this.isValidNumber(number)) {
          this.errorNumberFormat = '';
      } else {
          this.errorNumberFormat = this.$i18n.t('message.login.error3');
      }
    },
    validateCode(code) {
      if (this.isValidCode(code.trim())) {
          this.errorInvalidCode = '';
      } else {
          this.errorInvalidCode = this.$i18n.t('message.login.error4');
      }
    },
    isValidNumber() {
      const exp = /(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -.]*\d+)*[) ]*$/g;
      const exp2Str = /^(\+)?[0-9]*$/g;
      let trimmedNumber = this.number.trim();

      const isValid = exp.test(trimmedNumber);

      let cleanNumber = trimmedNumber.replace('(', '');
      cleanNumber = cleanNumber.replace(')', '');
      cleanNumber = cleanNumber.replace(' ', '');
      cleanNumber = cleanNumber.replace('-', '');

      const isValid2 = exp2Str.test(cleanNumber);
      if (isValid && isValid2) {
        if (!cleanNumber.startsWith('+') && cleanNumber.length === 10) {
            this.validatedNumber = `1${cleanNumber}`;
        } else if (cleanNumber.startsWith('+')) {
            this.validatedNumber = cleanNumber.replace('+', '');
        } else {
            this.validatedNumber = cleanNumber;
        }

        return true;
      }
      return false;
    },
    isValidCode(code) {
      const exp = /^[0-9]{6}$/g
      return exp.test(code);
    },

  },
  watch: {
    apiError(current) {
      if (current && (current.code === ERROR_CODES.VERIFICATION_EXPIRED || current.code === ERROR_CODES.EXPIRED_REFRESH_TOKEN) ) {
        this.authStep = 1;
        this.errorMessage = undefined;
        this.errorInvalidCode = '';
        this.code = '';
        this.number = this.userLoginNumber;
      } else {
          this.errorInvalidCode = '';
      }
    },
    userLoginNumber(current) {
      if (current && !this.number && this.apiError) {
          this.number = current;
      }
    },
    loading(current) {
      // console.log('LOADING: ', current)
    },
    loggedIn(current) {
      if(current) {
        this.authStep = 1;
        this.inputStepRef = 'inputStep1';
        this.validatedNumber = '';
        this.number = '';
        this.code = '';
        this.validatedNumber = '';
        this.$router.push({ name: 'manage' });
      }
    },

    number(current) {
      this.validateNumber(current);
    },

    code(current) {
      this.validateCode(current);
    },

    errorInvalidCode(current) {

    },


    async isAuthenticated(current) {
      // if (current === true) {
      //   if (this.$route.query && this.$route.query.redirect) {
      //     // Redirect!
      //     // this.$router.push({ path: this.$route.query.redirect });
      //       this.$router.push({ name: 'dashboard' });
      //   } else {
      //     this.$router.push({ name: 'dashboard' });
      //   }
      // }
    },
    verifyNumberId(current) {
      if (current) {
        this.authStep = 2;
        this.inputStepRef = 'inputStep2';
      }
    },
    verifyNumberErr(current) {
      if (current) {
        this.errorMessage = current;
      }
    },
  },

  created() {
    if (this.loggedIn) {
      // this.$router.push('dashboard');
        this.$router.push({ name: 'manage' });
    }
    if (this.userLoginNumber && !this.number) {
        this.number = this.userLoginNumber;
        this.errorInvalidCode = '';
    }
  },
  beforeDestroy() {
    this.authStep = 1;
  }
};
</script>

<style scoped lang="scss">
  .St-home {
    align-items: center;
    display: flex;
    height: 50vh;
    justify-content: center;
  }

  .St-login {
    max-width: 600px;
    width: 100%;
  }

  .St-login__logo {
    max-width: 200px;
  }

  .Vlt-btn {
    width: 100%;
  }

  .St-home {
    height: 100%;
  }

  .St-login {
    max-width: 600px;
    width: 100%;
    padding: 100px 0 0 0;
  }

  .textContainer {
    padding-right: 8px;
  }

  .logoContainer {
    margin-top: 3px;
    padding-left: 0;

    img {
      height: 26px;
    }
  }

  .logoText {
    font-size: 2.3em;
    font-weight: 500;
    padding: 15px 0 0 0;
    font-family: 'spezia', sans-serif;
  }

  .logoImg {
    padding-left: 8px;
  }
</style>
